var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartdevice = function SvgSmartdevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "smartdevice_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 88H12C5.372 88 0 82.628 0 76V12C0 5.372 5.372 0 12 0h84c6.628 0 12 5.372 12 12v36"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 91a3 3 0 1 0 0-6v6Zm29-43a3 3 0 1 0 6 0h-6ZM76 85H12v6h64v-6Zm-64 0a9 9 0 0 1-9-9h-6c0 8.285 6.715 15 15 15v-6Zm-9-9V12h-6v64h6Zm0-64a9 9 0 0 1 9-9v-6C3.715-3-3 3.715-3 12h6Zm9-9h84v-6H12v6Zm84 0a9 9 0 0 1 9 9h6c0-8.285-6.715-15-15-15v6Zm9 9v36h6V12h-6Z",
    fill: "#fff",
    mask: "url(#smartdevice_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 118.5H84a6.5 6.5 0 0 1-6.5-6.5V56a6.5 6.5 0 0 1 6.5-6.5h28a6.5 6.5 0 0 1 6.5 6.5v56a6.5 6.5 0 0 1-6.5 6.5ZM12 40v8M96 108h4",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSmartdevice;